export default __webpack_public_path__ + "static/media/icon-opportunities.51d1f541.svg";